// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_timetable,
  add_timetable,
  update_timetable,
  delete_timetable,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const todayIndex = new Date().getDay();


const initialState = {
  timetables: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,


  formData: {
    teacher: "",
    day: days[todayIndex],
    section: "",
    school_class: "",
    subject: "",
    period: "",
    subject: "",
  },
  filterData: {
    day: days[todayIndex],
    section: "",
    school_class: "",
  },
};




// Async Thunks for API Calls
export const fetchtimetable = createAsyncThunk(
  "timetable/fetchtimetable",
  async (
    { page, page_size, school_id,day,
        class_id,
        section_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_timetable(
        page,
        page_size,
        school_id,
        day,
        class_id,
        section_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createtimetable = createAsyncThunk(
  "timetable/createtimetable",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_timetable(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatetimetable = createAsyncThunk(
  "timetable/updatetimetable",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_timetable(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletetimetable = createAsyncThunk(
  "timetable/deletetimetable",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_timetable({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const timetableSlice = createSlice({
  name: "timetables",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        teacher,
        day,
        section,
        school_class,
        start_time,
        end_time,
        subject,
      } = action.payload;
      state.formData = {
        id,
        teacher,
        day,
        section,
        school_class,
        start_time,
        end_time,
        subject,
      };
    },
    resetFormData(state) {
      state.formData = {
        teacher: "",
        day: "",
        section: "",
        school_class: "",
        start_time: "",
        end_time: "",
        subject: "",
      };
    },
    settimetable(state, action) {
      state.timetables = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchtimetable.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchtimetable.fulfilled, (state, action) => {
        state.loading = false;
        state.timetables = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchtimetable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createtimetable.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createtimetable.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createtimetable.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatetimetable.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatetimetable.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatetimetable.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletetimetable.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletetimetable.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletetimetable.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  settimetable,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,
} = timetableSlice.actions;
export default timetableSlice.reducer;
